import { InjectionToken } from '@angular/core';
import { BuyProductDataConfig } from '@prlw/data/buy-product/buy-product-data.module';

export const BUY_PRODUCT_DATA_CONFIG = new InjectionToken<BuyProductDataConfig>(
  'buy-product-data-config',
);
